import type { VehicleStatsByCompany } from '../../../../generated/graphql'

export const total = ({ total: _total }: VehicleStatsByCompany): string =>
    _total && Number.isFinite(_total) ? `${_total}` : ''
